
export enum Allergens {
    Celery = 'Celery',
    Egg = 'Egg',
    Fish = 'Fish',
    Gluten = 'Gluten',
    Lupins = 'Lupins',
    Milk = 'Milk',
    Molluscs = 'Molluscs',
    Mustard = 'Mustard',
    Nuts = 'Nuts',
    SesameSeeds = 'SesameSeeds',
    SoyaBeans = 'SoyaBeans',
    SulphurDioxide = 'SulphurDioxide',
}
